import { api } from "../Apis/interceptor";
import { setToken } from "./authService";

//SERVICE FOR GENERATE CODE AND SEND EMAIL
export const mfaGenerate = async (email, username, operatingSystem) => {
  try {
    const res = await api.post("/api/v1/mfa", {
      email: email,
      username: username,
      operatingSystem: operatingSystem,
    });
    // if (res) {
    //   setToken(res.data.token);
    //   localStorage.setItem("dashboardURL", res.data.dashboardURL);
    // }
    return res.data;
  } catch (err) {
    if (err) {
      console.log("err", err);
    }
  }
};

//SERVICE FOR OTP VERIFICATION
export const mfaVerification = async (email, otp, username) => {
  try {
    const res = await api.post("/api/v1/otp", {
      email: email,
      otp: otp,
      username: username,
    });
    // if (res) {
    //   setToken(res.data.token);
    //   localStorage.setItem("dashboardURL", res.data.dashboardURL);
    // }
    return res.data;
  } catch (err) {
    if (err) {
      console.log("err", err);
    }
  }
};
